<template>
    <div class="row col-12 mt-3 justify-content-center">
        <div class="col-6">
            <button class="btn btn-secondary fw-bold p-3 w-100" @click="formularioStore.voltar()">
                VOLTAR
            </button>
        </div>
    </div>
</template>

<script setup>
import { useFormularioStore } from '@/store/formulario'
const formularioStore = useFormularioStore()
</script>